module.exports = __webpack_public_path__ + "img/exclamation-circle-regular.c28ecd7c.svg";